import { render, staticRenderFns } from "./BankDetailsModal.vue?vue&type=template&id=150bea22&"
import script from "./BankDetailsModal.vue?vue&type=script&lang=js&"
export * from "./BankDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports